import WorkExperienceContainer from './WorkExperienceContainer';

// Descriptions are authored with FieldTextEditor, so they are stored as HTML
// (paragraphs, bold, bullet and numbered lists) and rendered as HTML here.
const profileUser = {
  id: { uuid: 'work-experience-example-user' },
  type: 'user',
  attributes: {
    profile: {
      displayName: 'Testi K',
      abbreviatedName: 'TK',
      publicData: {
        workExperience: [
          {
            id: 'we-1',
            customerName: 'Shine',
            task: 'SEO & Growth Marketing Specialist',
            startMonth: 6,
            startYear: 2024,
            endMonth: 12,
            endYear: 2025,
            jobContinues: false,
            description:
              '<p>Product/service marketed: <strong>All-in-one financial platform for SMEs</strong></p><p><br></p><ul><li>Conducted in-depth keyword research to identify high-traffic opportunities and optimized on-page content to rank for competitive search terms</li><li>Performed comprehensive audits to identify issues such as broken links, crawl errors, and slow page speeds</li></ul>',
          },
          {
            id: 'we-2',
            customerName: 'Zervant',
            task: 'Growth Marketer',
            startMonth: 10,
            startYear: 2019,
            endMonth: 6,
            endYear: 2024,
            jobContinues: false,
            description:
              '<p>Invoicing software for entrepreneurs and SMEs.</p><ol><li>Managed day-to-day website updates and maintenance</li><li>Designed and launched a comprehensive SEO strategy, increasing website traffic by 300% YoY</li></ol>',
          },
        ],
      },
    },
  },
};

export const Default = {
  component: WorkExperienceContainer,
  props: { profileUser },
  group: 'users',
};
